var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21554",
    "data-name": "Group 21554",
    transform: "translate(-892 -804)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21551",
    "data-name": "Group 21551",
    transform: "translate(894.667 809.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17743",
    "data-name": "Path 17743",
    className: "cls-1",
    d: "M15 12a3 3 0 1 1-3-3 3 3 0 0 1 3 3z",
    transform: "translate(-2.458 -4.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17744",
    "data-name": "Path 17744",
    className: "cls-1",
    d: "M2.458 12a10 10 0 0 1 19.084 0 10 10 0 0 1-19.084 0z",
    transform: "translate(-2.458 -5)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19851",
    "data-name": "Rectangle 19851",
    transform: "translate(892 804)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d8c815792e779720b07b4b50928cd4fe.svg";
export { ForwardRef as ReactComponent };